import React from 'react';
import MultiSeriesRadialChartCard, {
  LegendFormatterFn
} from '../../../../charts/MultiSeriesRadialChartCard';

interface ActivitiesWeekSpotCheckChartProps {
  activityCompletedCount?: number;
  activityTotalCount?: number;
  curriculumWeek?: number;
  curriculumWeekTotal?: number;
  spotCheckCompletedCount?: number;
  spotCheckTotalCount?: number;
  loading: boolean;
}

const ActivitiesWeekSpotCheckChart: React.FC<ActivitiesWeekSpotCheckChartProps> = ({
  activityCompletedCount = 0,
  activityTotalCount = 0,
  curriculumWeek = 0,
  curriculumWeekTotal = 0,
  spotCheckCompletedCount = 0,
  spotCheckTotalCount = 0,
  loading
}) => {
  const series = [
    {
      count: activityCompletedCount,
      total: activityTotalCount,
      color: '#33B9D2',
      label: 'Activities'
    },
    {
      count: curriculumWeek,
      total: curriculumWeekTotal,
      color: '#B9DFA8',
      label: 'Week'
    },
    {
      count: spotCheckCompletedCount,
      total: spotCheckTotalCount,
      color: '#B22F12',
      label: 'Spot Check'
    }
  ];

  const legendFormatter: LegendFormatterFn = seriesData => (seriesName, opts): string => {
    const series = seriesData[opts.seriesIndex];
    return `${series.count} ${series.label}`;
  };

  return (
    <MultiSeriesRadialChartCard
      legendFormatter={legendFormatter}
      loading={loading}
      seriesData={series}
    />
  );
};

export default React.memo(ActivitiesWeekSpotCheckChart);
